import React from "react";
import { NavLink } from "react-router-dom";
import { brandImages } from "../config/images";

/**
 * NavBar
 * Props:
 *  - brand: { name, fullName, tagline }
 *  - navItems: [{ label, path }]
 */
function NavBar({ brand, navItems }) {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-navy sticky-top shadow-sm py-2">
      <div className="container">
        <NavLink className="navbar-brand d-flex align-items-center gap-2" to="/">
          <img
            src={brandImages.logo}
            alt={`${brand.name} logo`}
            width="100"
            height="100"
            className="rounded-circle"
          />
          {/* <span>
            <span className="navbar-brand-text d-block lh-1">{brand.name}</span>
            <small className="d-none d-md-block" style={{ fontSize: "0.7rem", color: "var(--apk-saffron)" }}>
              {brand.tagline}
            </small>
          </span> */}
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#apkanzNavbar"
          aria-controls="apkanzNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="apkanzNavbar">
          <ul className="navbar-nav ms-auto gap-lg-2">
            {navItems.map((item) => (
              <li className="nav-item" key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === "/"}
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
